import { render, staticRenderFns } from "./ShortTermReview.vue?vue&type=template&id=4187cc92&"
import script from "./ShortTermReview.vue?vue&type=script&lang=js&"
export * from "./ShortTermReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports